import { Component } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { MenuStateService } from '../../services/menu.service';

@Component({
  selector: 'app-header',
  imports: [TegelModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  constructor(private menuState: MenuStateService) {}

  mobileMenuAction(): void {
    this.menuState.setSignal(true);
  }
}
